import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';
import { AttachmentRemoteDto } from 'src/generated/swagger';
import { SamwinCallListState } from '../../samwin-call-list/samwin-call-list.state';
import { EmailDialogBehaviourState, EmailDialogBehaviourStateInstance, EmailDialogBehaviourStateModel } from './email-dialog-behaviour.state';

export class EmailDialogSelectors {
   @Selector([EmailDialogBehaviourState])
   public static isStateContainingInstance(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return !_.isNil(state[messageId]);
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static hasReferenceMail(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return !_.isNil(state[messageId]?.referencedEmail);
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static getReferenceAttachments(state: EmailDialogBehaviourStateInstance): (messageId: string) => AttachmentRemoteDto[] {
      return (messageId: string) => {
         const attachments = state[messageId]?.attachments;
         if (!_.isNil(attachments)) {
            return _(Object.keys(attachments).map((key) => attachments[key])).value();
         }
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static getPurpose(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return state[messageId]?.purpose;
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static getRequestingSkill(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return state[messageId]?.requestingSkill;
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static getTemplateContextData(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return state[messageId]?.contextData;
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static getSelectedTemplate(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return state[messageId]?.selectedTemplate;
      };
   }

   @Selector([EmailDialogBehaviourState, SamwinCallListState.getCallList])
   public static isEmailingInProgress(state: EmailDialogBehaviourStateInstance, callList: SamwinCallInfoRemoteDto[]) {
      return (messageId: string) => {
         return _.isNil(state[messageId]?.purpose);
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static isTemplateSelected(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return _.isNil(state[messageId]?.selectedTemplate);
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static isLoadingTemplates(state: EmailDialogBehaviourStateInstance) {
      return (messageId: string) => {
         return _.isNil(state[messageId]?.selectableTemplates);
      };
   }

   @Selector([EmailDialogBehaviourState])
   public static getFilteredTemplates(state: EmailDialogBehaviourStateModel) {
      return (messageId: string) => {
         const behaviour = state[messageId];
         return _(behaviour?.selectableTemplates)
            .filter((queue) => {
               return (
                  _.isEmpty(behaviour.searchText) ||
                  behaviour.searchText.split(' ').every((criterion) => queue.name.toLowerCase().includes(criterion.toLowerCase()))
               );
            })
            .orderBy((queue) => queue.name.toLowerCase(), 'asc')
            .value();
      };
   }
}
